'use strict';

module.exports = function(document, name) {
	var event = document.createEvent('CustomEvent');
	event.initCustomEvent(name, true, true, null);
	document.dispatchEvent(event);
};